import { IEnv } from './env.type'

export const environment: IEnv = {
  PRODUCTION: true,
  API_PREFIX: 'https://api.dilan-mirror.com',
  SOCKET_PREFIX: 'wss://api.dilan-mirror.com',
}
